import {  useState  } from 'react';
import { Calculator, Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { ThemeToggle } from './ThemeToggle';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="w-full py-4 px-6 backdrop-blur-lg bg-white/80 dark:bg-gray-900/80 fixed top-0 z-40 border-b border-gray-100 dark:border-gray-800 transition-colors duration-200">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between">
          {/* Logo and Brand */}
          <div className="flex items-center gap-2">
            <Calculator className="w-8 h-8 text-indigo-600 dark:text-indigo-400" />
            <Link to="/" className="text-xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 dark:from-indigo-400 dark:to-purple-400 bg-clip-text text-transparent">
              MathMaster
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6">
            <Link to="/" className="hover:underline">
              Times Tables
            </Link>
            <Link to="/squares" className="hover:underline">
              Squares
            </Link>
            <Link to="/cubes" className="hover:underline">
              Cubes
            </Link>
            <Link to="/fractions" className="hover:underline">
              Fractions
            </Link>
            <Link to="/advanced" className="hover:underline">
              Advanced
            </Link>
            <Link to="/how-to-play" className="hover:underline">
              How to Play
            </Link>
          </nav>

          {/* Theme Toggle and Mobile Menu Button */}
          <div className="flex items-center gap-4">
            <ThemeToggle />
            <button
              onClick={toggleMenu}
              className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors md:hidden"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? (
                <X className="w-6 h-6 text-gray-700 dark:text-gray-200" />
              ) : (
                <Menu className="w-6 h-6 text-gray-700 dark:text-gray-200" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div
          className={`${
            isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          } md:hidden overflow-hidden transition-all duration-300 ease-in-out`}
        >
          <nav className="flex flex-col gap-4 py-4">
            <Link to="/" className="hover:underline" onClick={closeMenu}>
              Times Tables
            </Link>
            <Link to="/squares" className="hover:underline" onClick={closeMenu}>
              Squares
            </Link>
            <Link to="/cubes" className="hover:underline" onClick={closeMenu}>
              Cubes
            </Link>
            <Link to="/fractions" className="hover:underline" onClick={closeMenu}>
              Fractions
            </Link>
            <Link to="/advanced" className="hover:underline" onClick={closeMenu}>
              Advanced
            </Link>
            <Link to="/how-to-play" className="hover:underline" onClick={closeMenu}>
              How to Play
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};